import { AodRun, AodRunStatusEnum } from '@app/modules/audit/modules/aod/aod.types';
import { Box } from '@mui/material';
import { CircularProgressWithLabel } from '../../../../../components/base/CircularProgressWithLabel';
import { AodRunStatus } from './AodRunStatus';

interface AodRunStatusWithProgressProps {
  run: AodRun;
  size?: 'small' | 'medium';
}

export function AodRunStatusWithProgress({ run, size = 'small' }: AodRunStatusWithProgressProps) {
  const { status, processJobStatus } = run;

  const processProgress =
    status === AodRunStatusEnum.IN_PROGRESS && processJobStatus?.progressPercent;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <AodRunStatus showEfficiency={false} run={run} size={size} />
      {processProgress && (
        <CircularProgressWithLabel
          value={processProgress as number}
          size={size === 'small' ? 32 : 48}
        />
      )}
    </Box>
  );
}
